export default {
  deeplinks: {
    'card': {
      name: 'deeplinks#card',
      params: (id) => ({ cardId: id }),
    },
    'deck': {
      name: 'deeplinks#deck',
      params: (id) => ({ deckId: id }),
    },
    'flashcard': {
      name: 'deeplinks#flashcard',
      params: (id) => ({ flashcardId: id }),
    },
    'navigation_group': {
      name: 'deeplinks#navigationGroup',
      params: (id) => ({ navigationGroupId: id }),
    },
    'purchase_order': {
      name: 'deeplinks#purchaseOrder',
      params: (id) => ({ purchaseOrderId: id }),
    },
    'qotd': {
      name: 'qotd#index',
      params: () => {},
    },
    'topic': {
      name: 'deeplinks#topic',
      params: (id) => ({ topic: id }),
    },
    'upgrade': {
      name: 'home',
      params: () => { },
      query: {
        upgrade: true,
      },
    },
  },
};
